import { ChangeDetectorRef, Component, OnDestroy, OnInit,ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { SseService } from 'src/app/services/SseService';
import { GestionService } from 'src/app/services/gestion.services';
import { MatDialog } from '@angular/material/dialog';
import { ReconfiguracionDialogComponent } from '../reconfiguracion-dialog/reconfiguracion-dialog.component';
import { TemaService } from 'src/app/services/tema.services';
import { GestorDialogComponent } from './gestor-dialog/gestor-dialog.component';
import { Notificacion } from 'src/app/models/notificacion';
import { NotificacionService } from 'src/app/services/notificacion.service';
import { operationinterface } from 'src/app/interface/OperationInterface';
import { RealTimeService } from 'src/app/services/realtime.service';
import { SuscripcionesConfirmarComponent } from '../broker/suscripciones-confirmar/suscripciones-confirmar.component';
import { ColaOrdenesService } from '../../services/cola-ordenes.service';
import { PosicionesService } from '../../services/posiciones.service';
import { ToastrService } from 'ngx-toastr';
import { CompaniaWebsocketService } from 'src/app/services/compania-websocket.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MarketDataService } from '../../services/market-data.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TablamercadoComponent } from '../tablamercado/tablamercado.component';
import { PlanificadorGestionComponent } from '../models/gestion/gestion.component';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';
import { HelpDialogComponent, HelpDialogData } from '../common/help-dialog/help-dialog.component';

@Component({
  selector: 'app-gestor',
  templateUrl: './gestor.component.html',
  styleUrl: './gestor.component.scss'
})
export class GestorComponent implements OnInit, OnDestroy {
  @ViewChild(TablamercadoComponent) tablaMercado: TablamercadoComponent;
  @ViewChild(PlanificadorGestionComponent) gestionComp: PlanificadorGestionComponent;
  lastBusinessDay:any;
 
  private unsubscribe$ = new Subject<void>();
  activadoauto: boolean = false;
  buscarentradas: boolean = false;
  errString: string = '';
  private idnectumsArray: number[] = []; // Array para almacenar idnectums de cartera + mercado
  private mercadoIdnectumsArray: number[] = []; // Array para almacenar idnectums de las primeras 10 compañías de tabla mercado
  public selectedTab: number = 0;
  public loading: boolean = false;
  public vla: any[] = [];

  existemargen: boolean = true;
  existeriesgo: boolean = true;
  efectivopositivo: boolean = true;
  colaOrdenes: any[] = [];
  ordenPendiente: boolean = false;
  disabledByAccount: boolean = false;
  public listModelo: any;
  public mercados: any;
  public intervalos: any;
  public operacion: operationinterface;
  public diaHabil: boolean = false;
  private subscription: Subscription;
  public listaMercado: boolean = localStorage.getItem('gestor_panel_listaMercado') !== 'false';
  public cartera: boolean = localStorage.getItem('gestor_panel_cartera') !== 'false';
  public texto: string = ">>"
  public mouseSobreDiv: boolean = false;
  private panelTimeout: any;
  public subGestOptima: Subscription;
  public subtema: Subscription;
  public subCarteraTemporal: Subscription;
  public subActualizar: Subscription;
  public isDark: boolean = false;
  public licencia: string;
//  private operacionesPendientes: Subscription;
  public operacionesActuales: operationinterface[] = [];
  public operacionesActualesSalida: operationinterface[] = [];
  public suscrito: boolean = false;
  public revisadosuscrito: boolean = false;
  public isGestion: boolean = true;
  public idcarterasuscrita: number = 0;
  posicionesModel: operationinterface[];
  idcartera: number = 0;
  lastBusinessDayData: any;
  accountType: string[] = [
    'MARGEN',
    'NOMINAL'
  ]

  purchaseTypes: string[] = [
    'LIMITADO',
    'FIJO'
  ]

  public carteraTemporal: any;

  optimalWallet: OptimalWallet;
  theme: string;
  iniciadoTiempoReal: boolean = false;
  private idnectumsSubscription: Subscription;
  private static readonly RECALCULO_MAX_MS = 5 * 60 * 1000;
  /** Date.now() del recálculo en curso, 0 si no hay ninguno (ver getOptimalWallet). */
  private recalculoEnCurso = 0;
  private recalculoPendiente: { data: any; endpoint: string; isGestion: boolean; isBRoker: boolean } | null = null;

  constructor(private router: Router, private _sseService: SseService, private colaOrdenesService: ColaOrdenesService,
    public _cookieService: CookieService,
    private apiService: ApiService, private toastr: ToastrService,
    private _gestionsv: GestionService,
    public dialog: MatDialog,
    public _route: ActivatedRoute,
    private temaservicio: TemaService,
    private cdr: ChangeDetectorRef,
    private notificacionService: NotificacionService, private _realTimeService: RealTimeService,
    private posicionesService: PosicionesService, private companiaWebsocketService: CompaniaWebsocketService,
    private marketDataService: MarketDataService
  ) {
    this.licencia = this._cookieService.get('auth_token');
  }

  ngOnInit(): void {

    this._gestionsv.activadoAuto$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(isActivated => {
        this.activadoauto = isActivated;
        console.log("Activado auto actualizado:", this.activadoauto);
      });

    //cuando se abre por url
    this._route.queryParams.subscribe(params => {
      const idcartera = params['idcartera'];
      console.log("ID CARTERA: ", idcartera);
      this.idcartera = idcartera;
      if (idcartera) {
        this.abrirCartera(idcartera);
      }
    });

    this.idnectumsSubscription = this._gestionsv.idnectumsArray$.subscribe(
      (newIdnectums: number[]) => {
        console.log('>>> GESTOR: Recibido del servicio idnectumsArray$:', newIdnectums);
        this.mercadoIdnectumsArray = newIdnectums;
        // Actualizar el socket con los nuevos IDs de mercado
        this.updateIdnectumsArray();
      }
    );
    this.subCarteraTemporal = this._gestionsv.valGestIdeCarteras$.subscribe({
      next: (data: any) => {
        this.carteraTemporal = data;
      }
    });
    this.apiService.apiPost("parametricaparamodelos", true, {}, 2).then((response) => {
      this.intervalos = (response.data.periodos);
    })
    this.subGestOptima = this._gestionsv.valgestOptimaWallet$.subscribe({
      next: (data: any) => {
        this.optimalWallet = data;
        if (!this.revisadosuscrito && this.optimalWallet.idcartera != null) {
          this._sseService.apiGetNew('obtenerIdCartera2?idcartera=' + this.optimalWallet.idcartera).subscribe({
            next: (data: any) => {
              if (data.status === 'success') {
                console.log('IdCartera2:', data.idcartera2);
                // Aquí puedes hacer lo que data con el idcartera2
                //this.suscrito = true;
                console.log(data.idcartera2 + ' idcartera2 ');
                this.idcarterasuscrita = data.idcartera2;
              } else {
                console.error('Error:', data.message);
              }
            }
          });
          this._sseService.apiGetNew('revisarSuscrito?nombre='+encodeURIComponent(data.nombre)).subscribe({
            next: (data: any) => {
              if(data.status==='success') {
              this.suscrito = true;
              }else{
                this.suscrito = false;
              }
            }
          });
          this.revisadosuscrito = true;
        }
      }
    });
    this.subtema = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any) => {
        this.isDark = data;
        this.theme = data ? 'dark-theme' : 'light-theme';
      }
    });
    this.subActualizar = this._gestionsv.valactualizarCartera$.subscribe({
      next: (data: any) => {
        if (data) {
          console.log('getOptimalWallet 2');
          console.log(data);
          this.getOptimalWallet(this.optimalWallet, 'Recalcular?', true, false);
          this._gestionsv.updateactualizarCartera(false);
        }
      }
    });
    this.iniciarContadorRegresivo();
    setInterval(() => {
      // console.log(' ordncola length ' + this.colaOrdenes.length + ' existemargen' + this.existemargen + ' ordenpendiente ' + !this.ordenPendiente);
      if (this.colaOrdenes.length > 0 && !this.existemargen && !this.existeriesgo)
        this.colaOrdenes = this.colaOrdenes.filter(orden => orden.tipoOperacion !== 'ENTRADA');

      if (this.colaOrdenes.length > 0 && this.optimalWallet.idcartera != null && !this.existemargen && !this.existeriesgo && !this.ordenPendiente && this._cookieService.check('auto' + this.optimalWallet.idcartera)) {

        this.crearordenbroker('broker/orderNuevo', this.colaOrdenes[0], this.licencia, '/iserver/account/' + this.optimalWallet.nombre + '/orders ');

        this.colaOrdenes.shift();
      } else {
        // console.log('no se puede enviar orden ');
      }
    }, 2000);
    this.subscription = this.companiaWebsocketService.getCompaniaUpdates()
      .subscribe(
        (data) => {
          console.log('Received data gestor:', data);
          this.updateValCartera(data);
          
        },
        (error) => console.error('Error:', error)
      );

    // Restaurar anchos persistidos
    setTimeout(() => this.restoreSavedWidths?.(), 50);

  }
  updateValCartera(data: any) {
    // Siempre enviar los datos al servicio de market data para actualizar la tabla de mercado
    this.marketDataService.updateMarketData(data);

    if (this.posicionesModel && this.posicionesModel.length > 0) {
      //console.log(this.optimalWallet);
      //console.log(this.posicionesModel)
      const updatedPositions = this.posicionesModel.map(position => {
        if (position.idNectum === data.idnectum) {
          // Update the position with the new close price
          let valtemp = this.calculateValorLatente(position, data.close);
          //console.log(data);
          return {
            ...position,
            preciocierre: data.close,
            cotizacion: data.close,
            valorlatente: valtemp,
            profit:  '('+(Math.abs(position.porprofit)*100)+') ' + (data.close + (data.close * Math.abs(position.porprofit)) ).toFixed(2),
            stoplossactual:  '('+Math.abs(position.porstoploss)*100+') ' + (data.close - (data.close * Math.abs(position.porstoploss))).toFixed(2) ,
            valorlatentepor: ((valtemp / (position.precioentradareal * position.cantidadacciones) * 100)),
            horaCotizacion: Math.floor(Date.now() / 1000), // Unix timestamp in seconds
          };
        }
        return position;
      });

      // Update the posicionesModel with the new data
      this.posicionesModel = updatedPositions;
      this._gestionsv.updategestValPos(this.posicionesModel);
      //console.log('Updated posicionesModel:', this.posicionesModel);

      //recorrer val[0] recorriendo con un foreach y reemplazar si fechaintervalo = this.lastbusinessday e idnectum = data.idnectum
      /**if (this.vla[0].length > 0) {
        this.vla[0].forEach((val: any) => {
          if (val.fechaintervalo === this.lastBusinessDay && val.idnectum === data.idnectum) {
          console.log('se encontro la posicion para reemplazar'+ val.idnectum);
            val.val = data.close;
            val.valpor = (val.val / (val.preciocierre * val.cantidadacciones) * 100);
          }
        });
        this._gestionsv.updategestValLatente(this.vla);
      }**/
      //actualizar en la vista 
      


    } else {
      console.log('No positions found in posicionesModel');
    }
  }

  // Helper method to calculate valor latente
  private calculateValorLatente(position: any, newClosePrice: number): number {
    const difference = newClosePrice - position.precioentradareal;
    return difference * position.cantidadacciones;
  }

  abrirCartera(idcartera: number) {
    let dataJson = {
      idcartera: idcartera
    };
    this._sseService.apiPostNew('getCarteraById', dataJson, this.licencia).subscribe({
      next: (data: any) => {
        console.log(data.cartera);
        //this.optimalWallet = data.cartera;
        this._gestionsv.updategestOptimaWallet(data.cartera);
        // Trigger any necessary updates
        console.log('getOptimalWallet 3');
        this.getOptimalWallet(this.optimalWallet, 'Recalcular?', true, false);
        console.log(data.cartera);
       // if (this.tablaMercado) {
          this.tablaMercado.gestcarterabyid(data.cartera.idmercado);
        //}
      }
    });
  }

  private iniciarContadorRegresivo() {
    let toastrRef: any;
    let tiempoRestante = 32;
    const actualizarToastr = (tiempoRestante: number) => {
      this.notificacionService.updateTimerNotification(
        `Auto · ${this.notificacionService.formatTiempoRestante(tiempoRestante)}`,
        'Próxima ejecución'
      );
    };

    const intervalo = setInterval(() => {
      tiempoRestante--;
      //console.log('Tiempo restante:' + tiempoRestante + ' ' + this.activadoauto);
      if (this._cookieService.check('auto' + this.idcartera)) {
        actualizarToastr(tiempoRestante);
      } else {

        tiempoRestante = 32;
      }

      if (tiempoRestante < 0) {
        //clearInterval(intervalo);
        this.valoresTiempoReal();
        tiempoRestante = 32;
      }
    }, 1000);
  }
  valoresTiempoReal() {
    this._gestionsv.updateActivadoAuto(this.idcartera);
    console.log('Valores Tiempo Real');
    let operacionesTemporales: operationinterface[] = [];
    this.buscarentradas = this.existemargen && this.existeriesgo;
    console.log('buscarentradas' + this.buscarentradas + " " + this.existeriesgo + " " + this.existemargen);
    // console.log(" auto "+this._gestionsv.auto);
    console.log(" check cokie " + this.activadoauto + ' ' + new Date());
    if (this.optimalWallet.idcartera != null && this.colaOrdenes.length == 0 && this.activadoauto) {
      //this.operacionesPendientes = 
      this._sseService.apiPostNew('gestor/revisarModeloGestorIajava', '{"idModelo": "' + this.optimalWallet.idModelo + '", "idcartera": "' + this.optimalWallet.idcartera + '", "entradas": ' + this.buscarentradas + ' }', this.licencia).subscribe({
        next: (data: any) => {
          if (data.operaciones) {
            if (data.operaciones.length > 0) {
              data.operaciones.forEach((operacion: operationinterface) => {
                const index = this.operacionesActuales.findIndex((ope: operationinterface) => ope.isooper === operacion.isooper && ope.tipoOperacion === operacion.tipoOperacion);
                let fechaMilisegundos = new Date().getTime();
                //console.log(operacion);
                if (index === -1 && operacion.tipoOperacion != 'ACTUALIZACION') {
                  operacionesTemporales.push(operacion);
                  this.operacionesActuales.push(operacion);
                  let side = 'BUY';
                  let tipoOperacion = operacion.tipoOperacion;
                  if (tipoOperacion === 'SALIDA') side = 'SELL';
                  let bajistaStr = 'A';
                  if (operacion.bajista) {
                    bajistaStr = 'B';
                  }
                  let tempconid = operacion.conid;
                  let sectype = operacion.secType;
                  let ordersData = {
                    orders: [
                      {
                        orderType: 'MKT',
                        ticker: operacion.nombreCompania,
                        side: side,
                        quantity: operacion.cantidadacciones,
                        // listingExchange: 'SMART',//
                        remainingquantity: operacion.cantidadacciones,
                        acctId: this.optimalWallet.nombre,
                        cOID: 'nctminvst' + fechaMilisegundos + operacion.idNectum + '-' + operacion.isooper + ':' + bajistaStr,
                        secType: tempconid + ':'+sectype,
                        filledquantity: 0,
                        parentId: 'nctminvst' + fechaMilisegundos + operacion.idNectum + '-' + operacion.isooper + ':' + bajistaStr,
                        tif: 'DAY',
                        //  outsideRTH: false,
                        referrer: 'modelosdeinversion',
                        useAdaptive: false,
                        conid: tempconid,
                        price: 0, idmodelo: operacion.idmodelo,
                      }
                    ]
                  };
                  this.colaOrdenes.push(ordersData);
                  this.colaOrdenesService.updateColaOrdenesGestor(this.colaOrdenes);
                  this.colaOrdenesService.updateOperacionesGestor(this.operacionesActuales);
                }
              });
              console.log('getOptimalWallet 4');

              this.getOptimalWallet(this.optimalWallet, 'Recalcular?', true, false);
            } else {
              if(!data.status){
                this.toastr.error(data.msg,'Error', {
                  timeOut: 0,
                  extendedTimeOut: 0,
                  closeButton: true,
                  tapToDismiss: false,
                  disableTimeOut: true,
                  positionClass: 'toast-bottom-right'
                });
                this.activadoauto = false;
                this.colaOrdenesService.clearLocalStorageForCartera(this.optimalWallet.idcartera);
              }


            }
          } else{
            console.log('Error en la revisión de modelos');
          };
        },
        complete: () => {
          //          this.iniciarContadorRegresivo();

        }

      });
    } else {
      //    this.iniciarContadorRegresivo();

    }

  }

  disabledMargin(event: any) {
    console.log(event.target.value);
    if (this.optimalWallet.tipocuenta == 'MARGEN') {
      this.optimalWallet.poderCompra = 100000
      this.disabledByAccount = false;
    }
    else {
      this.optimalWallet.poderCompra = 200000
      this.disabledByAccount = true;
    }
  }

  getOptimalWallet(data: any, endpoint: string, isGestion: boolean, isBRoker: boolean) {
    // Con carteras grandes un recálculo puede durar más que el ciclo automático (32 s); lanzar
    // otro encima apilaba SSE procesando a la vez hasta colgar el navegador. Se guarda el último
    // pedido y se lanza al terminar. Caduca por si el SSE se cerró sin completar (disconnect()).
    if (this.recalculoEnCurso > 0 && Date.now() - this.recalculoEnCurso < GestorComponent.RECALCULO_MAX_MS) {
      this.recalculoPendiente = { data, endpoint, isGestion, isBRoker };
      return;
    }
    this.recalculoEnCurso = Date.now();
    let liqval: any[] = [];
    let ventOp: any[] = [];
    this.vla = [];
    let rentabilida: any[] = [];
    let riesgo: any[] = [];
    let rendimiendoAnual: any[] = [];
    let pos: any[] = [];
    let ope: any[] = [];
    this.loading = true;
    this.errString = '';
    //this.existemargen = true;
    //this.existeriesgo = true;
    //this.efectivopositivo = true;
    this._gestionsv.updateGestExecuteGrap(false);
    this._sseService.apiGetSse(endpoint, true, data).subscribe({
      next: (resp: any) => {
        if (resp.name === 'ope') {
          ope.push(resp.data);
          console.log(resp.name);
          if (isGestion) {
            this._gestionsv.updateGestOpe(ope);
          }
          var temp = resp.data[resp.data.length - 1];
          //console.log(temp);
          this.optimalWallet.margen = temp.margentotal.toFixed(2);
          this.optimalWallet.fondosDisponibles = temp.fondosdisponibles.toFixed(2);
          this.optimalWallet.poderCompra = temp.podercompra.toFixed(2);
          this.optimalWallet.efectivo = temp.efectivo.toFixed(2);
          this.optimalWallet.valorLiquidativo = temp.valorliquidativo.toFixed(2);
          this.optimalWallet.efectivo = temp.efectivo.toFixed(2);
          this.efectivopositivo = this.optimalWallet.efectivo > 0;
        } else if (resp.name === 'vla') {
          this.vla.push(resp.data);
          if (isGestion) {
            this._gestionsv.updategestValLatente(this.vla);
            this.lastBusinessDayData = this.getLastBusinessDayData(this.vla[0]);
            this.posicionesModel = this.posicionesService.agregarPosicionesDesdeUltimoValorLiquidativo(this.lastBusinessDayData, this.posicionesModel);
            this.updateIdnectumsArray();
            pos.push(this.posicionesModel);
            if (isGestion) {
              this._gestionsv.updategestValPos(pos);
            }

          }

        } else if (resp.name === 'vli') {
          liqval.push(resp.data);
          if (isGestion) {
            this._gestionsv.updategestValLiq(liqval);
          }

        } else if (resp.name === 'pos') {
          console.log("POS Data: ", resp.data);
          //pos.push(resp.data);
          //if (isGestion) {
          //this._gestionsv.updategestValPos(pos);
          //}
        }
        else if (resp.name === 'ven') {
          ventOp.push(resp.data);
          if (isGestion) {
            this._gestionsv.updategestValVentas(ventOp);

          }
        } else if (resp.name === 'ren') {
          rentabilida.push(resp.data);
          if (isGestion) {
            this._gestionsv.updategestRentabilidad(rentabilida);
          }
        } else if (resp.name === 'rie') {
          riesgo.push(resp.data);
          if (isGestion) {
            this._gestionsv.updategestRiesgo(riesgo);
          }
        } else if (resp.name === 'rea') {
          rendimiendoAnual.push(resp.data);
          if (isGestion) {
            this._gestionsv.updategestRendAnual(rendimiendoAnual);

          }
        } else if (resp.name === 'err') {
          this.errString += resp.data;
          let errorstring = resp.data;
          let titulo = '';
          if (errorstring.includes('han superado los Requerimientos de Margen')) {
            this.existemargen = false;
            titulo = 'Control Margin Call %';
          }
          if (errorstring.includes('Se ha superado los Requerimientos de Margen para su carter')) {
            this.existemargen = false;
            titulo = 'Control Margin Call %';
          }
          if (errorstring.includes('Se ha superado el riesgo máximo establecido')) {
            this.existeriesgo = false;
            titulo = 'Riesgo Maximo';
          }
          if (errorstring.includes('e ha superado el riesgo para una nueva operacion')) {
            this.existeriesgo = false;
            titulo = 'Riesgo para Nueva Operacion';
          }

          console.log("", resp.name);
          console.log(resp.data);
          this.toastr.error(resp.data, titulo, { timeOut: 30000, positionClass: 'toast-top-center' });
          this.guardarNotificacion(new Notificacion(titulo, errorstring, 'GESTOR - ' + this.optimalWallet.nombre));
        }
      }, error: (err) => {
        console.log("hubo un error")
        this.finRecalculo();
      }, complete: () => {
        console.log("se COMPLETO el envio de datos.");


        // Definimos las condiciones de error que estamos buscando
        const errorConditions = [
          'han superado los Requerimientos de Margen',
          'Se ha superado los Requerimientos de Margen para su carter',
          'Se ha superado el riesgo máximo establecido',
          'e ha superado el riesgo para una nueva operacion'
        ];
        console.log(' error ' + this.errString);
        //  if(this.errString.length > 0) {
        // Verificamos si alguno de estos errores está presente en errString
        if (this.errString.includes(errorConditions[0]) || this.errString.includes(errorConditions[1])) { this.existemargen = false; }
        else {
          this.existemargen = true;
        }
        if (this.errString.includes(errorConditions[2]) || this.errString.includes(errorConditions[3])) {
          this.existeriesgo = false;
        } else { this.existeriesgo = true; }


        //llamar a la grafica
        this._gestionsv.updategestOptimaWallet(this.optimalWallet);
        this._gestionsv.updateGestExecuteGrap(true);
        this.loading = false;
        this.cdr.detectChanges();
        this.finRecalculo();
      }
    });
  }

  private finRecalculo() {
    this.recalculoEnCurso = 0;
    const pendiente = this.recalculoPendiente;
    this.recalculoPendiente = null;
    if (pendiente) {
      this.getOptimalWallet(pendiente.data, pendiente.endpoint, pendiente.isGestion, pendiente.isBRoker);
    }
  }


  private getLastBusinessDayData(vlaData: any[]): any[] {
    // Última fecha en una pasada, sin ordenar: vlaData es el lote que muestra la tabla de valores
    // latentes y ordenarlo en sitio le cambiaba el orden. Mismo resultado que el sort estable
    // descendente anterior: primera fila con la fecha máxima y luego las de esa misma fecha.
    if (!vlaData || vlaData.length === 0) return [];
    let ultima = vlaData[0];
    let ultimaMs = new Date(ultima.fechaintervalo).getTime();
    for (const item of vlaData) {
      const ms = new Date(item.fechaintervalo).getTime();
      if (ms > ultimaMs) { ultima = item; ultimaMs = ms; }
    }
    this.lastBusinessDay = ultima.fechaintervalo;
    return vlaData.filter(item => item.fechaintervalo === this.lastBusinessDay);
  }

  showTab(tab: any) {
    if (tab == 'cartera') {
      console.log(tab);
      this.cartera = !this.cartera;
      localStorage.setItem('gestor_panel_cartera', String(this.cartera));
    } else {
      this.listaMercado = !this.listaMercado;
      localStorage.setItem('gestor_panel_listaMercado', String(this.listaMercado));
    }
  }

  private updateIdnectumsArray() {
    // IDs de las posiciones de la cartera
    const carteraIdnectums = this.posicionesModel ? this.posicionesModel.map(posicion => posicion.idNectum) : [];
    
    // IDs de las primeras 10 compañías de la tabla de mercado (ya vienen del servicio)
    const mercadoIdnectums = this.mercadoIdnectumsArray || [];
    
    console.log('>>> GESTOR updateIdnectumsArray - IDs cartera:', carteraIdnectums);
    console.log('>>> GESTOR updateIdnectumsArray - IDs mercado:', mercadoIdnectums);
    
    // Combinar ambos arrays sin duplicados
    const combinedIds = [...new Set([...carteraIdnectums, ...mercadoIdnectums])];
    
    this.idnectumsArray = combinedIds.filter(id => id != null);
    
    console.log('>>> GESTOR updateIdnectumsArray - IDs combinados:', this.idnectumsArray);

    // Solo reconectar si hay cambios en los IDs (se llama con cada lote 'vla' del recálculo)
    if (this.idnectumsArray.length > 0) {
      const ids = this.idnectumsArray.join(',');
      if (this.companiaWebsocketService.conectadoA(ids)) return;
      this.companiaWebsocketService.disconnect();
      console.log('>>> GESTOR: Conectando socket con IDs:', ids);
      this.companiaWebsocketService.connect(ids);
    } else {
      console.log('>>> GESTOR: No hay IDs para conectar al socket');
    }
  }

  expandirDiv() {
    if (this.panelTimeout) { clearTimeout(this.panelTimeout); this.panelTimeout = null; }
    this.texto = "<<";
    this.mouseSobreDiv = true;
  }
  contraerDiv() {
    this.panelTimeout = setTimeout(() => {
      this.texto = ">>";
      this.mouseSobreDiv = false;
    }, 200);
  }

  startResizing(event: MouseEvent, column: HTMLElement) {
    if (column && column.tagName === 'DIV') {
      const dataKey = column.getAttribute('data-key') || '';
      const minWidth = 200;
      const maxWidth = Math.floor(window.innerWidth * 0.7);
      const initialX = event.clientX;
      const initialWidth = column.offsetWidth;

      const mouseMoveListener = (mouseEvent: MouseEvent) => {
        let width = initialWidth + (mouseEvent.clientX - initialX);
        if (width < minWidth) width = minWidth;
        if (width > maxWidth) width = maxWidth;
        column.style.width = width + 'px';
      };

      const mouseUpListener = () => {
        document.removeEventListener('mousemove', mouseMoveListener);
        document.removeEventListener('mouseup', mouseUpListener);
        try {
          const w = column.offsetWidth;
          if (dataKey) localStorage.setItem(dataKey, String(w));
        } catch (e) {}
      };

      document.addEventListener('mousemove', mouseMoveListener);
      document.addEventListener('mouseup', mouseUpListener);
    }
  }

  private restoreSavedWidths(): void {
    try {
      const keys = ['gestor_col_cartera', 'gestor_col_lista'];
      keys.forEach(key => {
        const v = localStorage.getItem(key);
        if (v) {
          const el = document.querySelector(`[data-key="${key}"]`) as HTMLElement;
          if (el) el.style.width = v + 'px';
        }
      });
    } catch (e) {}
  }

  openDialog(): void {
    let cartera = JSON.parse(JSON.stringify(this.optimalWallet));
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    const dialogRef = this.dialog.open(ReconfiguracionDialogComponent, {
      width: '30%',
      minWidth: '380px',
      maxHeight: '90vh',
      panelClass: dialogClass,
      data: { optimaWallet: cartera, isBroker: false, idcarterasuscrita: this.idcarterasuscrita }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
    });
  }
  openDialogCartera(): void {

    console.log("DIALOLG CLASS this.theme:", this.theme);
    const dialogRef = this.dialog.open(GestorDialogComponent, {
      width: '800px',
      height: '580px',
      panelClass: this.theme
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
    });
  }

  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTab = event.index;
  }

  ngOnDestroy(): void {
    this.subGestOptima.unsubscribe();
    this.subtema.unsubscribe();
    this.subActualizar.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  guardarNotificacion(notificacion: Notificacion) {
    notificacion.estado = true;
    console.log(notificacion);
    this.notificacionService.guardarNotificacion(notificacion).subscribe({
      next: (value) => {
        //this.cd.markForCheck();
      },
      error: (err) => {
        console.log("Ocurrió un error actualizando la notificación");
      },
    });
  }

  crearordenbroker(urlapiorderNuevo: string, ordersData: any, licencia: string, urlNew: string) {
    //    console.log("this.ordersData.orders[0].cOID ", ordersData);
    let dataorden = ordersData;
    this._sseService.apiPostNew(urlapiorderNuevo, dataorden.orders, licencia).toPromise()
      .then(response => {
        console.log(response)
        if (!response.status) {
          console.log(response.msg);
        }
      }).catch(error => {
        this.toastr.error('Hubo un error ' + error.message, 'Error', { timeOut: 30000, positionClass: 'toast-top-center' });
      });
  }

  esDiaHabil(fecha: Date): boolean {
    const diaSemana = fecha.getDay();
    return diaSemana >= 1 && diaSemana <= 5;
  }

  confirmar(openInNewTab: boolean = false) {
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    let desd = new Date();
    
    this._gestionsv.valGestOp$.pipe(first()).subscribe(primerValor => {
      //console.log(primerValor[0][0].fechaOperacion);
      console.log(primerValor);
      if (Array.isArray(primerValor) && primerValor.length > 0) {
        // Check if the first element is an array and has at least one element
        if (Array.isArray(primerValor[0]) && primerValor[0].length > 0) {
          // Now we can safely access primerValor[0][0]
          if (primerValor[0][0] && primerValor[0][0].fechaOperacion !== undefined) {
            desd = primerValor[0][0].fechaOperacion;
          }
        }
      }
      const data = {
        idcartera: this.optimalWallet.idcartera,
        modulo: 'gestor',
        cartera: this.optimalWallet.nombre,
        idcarterasuscrita: this.idcarterasuscrita,
        desde: desd
      }
      if (openInNewTab) {
        // Open in a new tab using Angular Router
        const url = this.router.serializeUrl(
          this.router.createUrlTree(['/confirmar'], { queryParams: data })
        );
        window.open(url, '_blank');
      } else {
        this.dialog.open(SuscripcionesConfirmarComponent, {
          width: "100%",
          height: "80%",
          panelClass: dialogClass,
          data: data
        });
      }
    });
  }
reset(){
//    let url = 'reset';
    this.posicionesModel = [];
    let dataJson={
      idcartera: this.optimalWallet.idcartera
    }
    console.log("esto enviamos al backend: ", dataJson)
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      height: '200px',
      panelClass: this.theme,
      data: {
        msj: '¡Atencion! Todos los datos de operaciones se Eliminaran'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
      if (result) {
        //this.clearLocalStorageForCartera(this.BrokoptimalWallet.idcartera);
        this.colaOrdenesService.clearLocalStorageForCartera(this.optimalWallet.idcartera);

        this._sseService.apiPostNew('reset',dataJson, this.licencia).subscribe({
          next: (data: any)=>{
              console.log("desde reset",data);
              if(data.status){
                this._gestionsv.updateactualizarCartera(true); //updateactualizarCartera(true);
                this._gestionsv.updatecompaniaMercado([]);
                this.optimalWallet.capitalinicial=100000;
                this.optimalWallet.valorLiquidativo=0;
                this.optimalWallet.fondosDisponibles=100000;
                this.optimalWallet.poderCompra =200000;
                this.optimalWallet.efectivo=100000;
              }
              this.getOptimalWallet(this.optimalWallet, 'Recalcular?', true, false);
          }
        })
      } 
    });    
    
  }

  showCarteraHelp(): void {
    const helpData: HelpDialogData = {
      title: 'Ayuda - Cartera Óptima',
      items: [
        { term: 'Capital Inicial', description: 'El capital con el que se inicia la cartera.' },
        { term: 'Valor Liquidativo Neto', description: 'Valor actual de todos los activos de la cartera.' },
        { term: 'Efectivo', description: 'Dinero disponible para nuevas operaciones.' },
        { term: 'Tipo Cuenta', description: 'MARGEN (permite apalancamiento) o NOMINAL (sin apalancamiento).' },
        { term: 'Margen Requerido %', description: 'Porcentaje del capital requerido como garantía.' },
        { term: 'Control Margin Call %', description: 'Umbral de alerta para llamada de margen.' },
        { term: 'Riesgo Máximo %', description: 'Porcentaje máximo de capital que se puede arriesgar.' },
        { term: 'Tipo Riesgo', description: 'LIMITADO (según riesgo) o FIJO (cantidad fija).' },
        { term: 'Valor Riesgo', description: 'Valor monetario del riesgo por operación.' }
      ]
    };
    this.dialog.open(HelpDialogComponent, {
      width: '450px',
      data: helpData
    });
  }

  showRiesgoHelp(): void {
    const helpData: HelpDialogData = {
      title: 'Ayuda - Configuración Riesgo',
      items: [
        { term: 'Riesgo Máximo %', description: 'Porcentaje máximo del capital que se puede arriesgar en todas las operaciones abiertas.' },
        { term: 'Tipo Riesgo', description: 'LIMITADO: el tamaño de posición se calcula según el riesgo. FIJO: cantidad fija por operación.' },
        { term: 'Valor Riesgo', description: 'Cantidad monetaria máxima a arriesgar por cada operación individual.' },
        { term: 'Comisión 2/2', description: 'Comisión del broker aplicada tanto a la entrada como a la salida de cada operación.' },
        { term: 'Gastos Gestión', description: 'Porcentaje de gastos de gestión aplicados sobre el capital.' },
        { term: 'Gastos Préstamo %', description: 'Intereses por préstamo de acciones en operaciones en corto (bajistas).' },
        { term: 'Comprar/Vender Fracciones', description: 'Permite comprar fracciones de acciones en lugar de unidades completas.' }
      ]
    };
    this.dialog.open(HelpDialogComponent, {
      width: '450px',
      data: helpData
    });
  }

  showTabHelp(tab: string, event: Event): void {
    event.stopPropagation();
    const tabHelpData: { [key: string]: HelpDialogData } = {
      'gestion': {
        title: 'Ayuda - Gestión/Contabilidad',
        items: [
          { term: 'Resumen', description: 'Vista general del estado de la cartera con métricas principales.' },
          { term: 'Balance', description: 'Registro de movimientos de capital, depósitos y retiros.' },
          { term: 'Comisiones', description: 'Detalle de comisiones pagadas al broker por operaciones.' }
        ]
      },
      'operaciones': {
        title: 'Ayuda - Operaciones',
        items: [
          { term: 'Operaciones Abiertas', description: 'Posiciones actualmente en cartera con su rendimiento en tiempo real.' },
          { term: 'Histórico', description: 'Registro de todas las operaciones cerradas con sus resultados.' },
          { term: 'Filtros', description: 'Permite filtrar operaciones por fecha, tipo, activo, etc.' }
        ]
      },
      'valores': {
        title: 'Ayuda - Valores Liquidativos',
        items: [
          { term: 'VL Diario', description: 'Valor liquidativo neto de la cartera calculado al cierre de cada día.' },
          { term: 'Evolución', description: 'Gráfica de la evolución del valor de la cartera en el tiempo.' },
          { term: 'Drawdown', description: 'Máxima caída desde el punto más alto de la curva de capital.' }
        ]
      },
      'rendimientos': {
        title: 'Ayuda - Rendimientos/Riesgos',
        items: [
          { term: 'Rentabilidad', description: 'Porcentaje de ganancia o pérdida sobre el capital inicial.' },
          { term: 'Sharpe Ratio', description: 'Mide el rendimiento ajustado al riesgo de la cartera.' },
          { term: 'Volatilidad', description: 'Desviación estándar de los rendimientos, indica el riesgo.' },
          { term: 'Max Drawdown', description: 'Máxima pérdida porcentual desde un máximo histórico.' }
        ]
      },
      'cartera': {
        title: 'Ayuda - Cartera',
        items: [
          { term: 'Posiciones', description: 'Lista de activos en cartera con cantidad, precio y valor actual.' },
          { term: 'Ponderación', description: 'Porcentaje que representa cada activo del total de la cartera.' },
          { term: 'P&L', description: 'Ganancia o pérdida (Profit & Loss) de cada posición.' }
        ]
      }
    };
    const helpData = tabHelpData[tab];
    if (helpData) {
      this.dialog.open(HelpDialogComponent, {
        width: '450px',
        data: helpData
      });
    }
  }
}